// src/config.js
const BASE_URL = "https://shikshacms.shikshainitiative.org";

export default BASE_URL;
